import MonitorRule from './monitor-rule.vue';

export default MonitorRule;
